import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChallengePopupComponent } from './challenge-popup.component';

import { SimpleSelectModule } from '../simple-select/simple-select.module';
import { MotesMediaModule } from '../motes-media/motes-media.module';
import { QuizProgressModule } from '../quiz-progress/quiz-progress.module';

@NgModule({
    declarations: [
        ChallengePopupComponent,
    ],
    exports: [
        ChallengePopupComponent,

    ],
    imports: [
        CommonModule,
        SimpleSelectModule,
        MotesMediaModule,
        QuizProgressModule
    ]
})
export class ChallengePopupModule { }
